import type { RiskSeverity } from '../types'
import { ExpandableSignal, RISK_DOT_COLOR } from './expandable-signal'

export interface EvaluationRiskListProps {
  /** Already ordered most severe first. */
  risks: { label: string; severity: RiskSeverity; detail: string }[]
}

/** The evaluation's risks as one global list, never inside a dimension card. */
export function EvaluationRiskList({ risks }: EvaluationRiskListProps) {
  if (risks.length === 0) return null
  return (
    <section className="mt-10">
      <h2 className="mb-4 text-xs font-semibold uppercase tracking-widest text-muted-foreground/80">
        Risks
      </h2>
      <div className="space-y-2">
        {risks.map((r) => (
          <ExpandableSignal
            key={r.label}
            title={r.label}
            content={r.detail}
            dotColor={RISK_DOT_COLOR[r.severity]}
          />
        ))}
      </div>
    </section>
  )
}
